var render = function render(){
  var _vm$global$profile, _vm$global$profile2, _vm$global$profile3, _vm$global$profile4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.design ? _c('div', {
    staticClass: "fill-height overflow-auto"
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.loadDesignStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.saveDesignStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.submitDesignStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.deleteDesignStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.handleUploadStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.handleUploadStaticStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.cloneStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.submitMediaStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.deleteMediaStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.updateMediaDescriptionStatus
    }
  }), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "upload-static-image-input",
    attrs: {
      "type": "file",
      "accept": "image/jpeg,image/png"
    }
  }), _c('dialog-scroll-lock', {
    attrs: {
      "width": "800"
    },
    model: {
      value: _vm.showHelp,
      callback: function ($$v) {
        _vm.showHelp = $$v;
      },
      expression: "showHelp"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', [_vm._v("Getting started")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showHelp = false;
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.mdiClose))])], 1)], 1), _c('v-card-subtitle', [_vm._v(" Click the help button "), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiHelpCircle)
    }
  }), _vm._v(" to bring up this dialog at any time ")], 1), _c('v-divider'), _vm.isApplying ? [_c('v-card-text', {
    staticClass: "pt-5"
  }, [_c('b', [_vm._v("For applicants")]), _c('br'), _vm._v("This is the same tool that is used to add designs to our catalog, but designs submitted during the application process will "), _c('b', [_vm._v("not")]), _vm._v(" be publicly released without a licensing agreement in place. ")]), _c('v-divider')] : _vm._e(), _c('v-card-text', {
    staticClass: "pt-5"
  }, [_c('ul', [_c('li', [_vm._v("Give your design a logical name. This is "), _c('b', [_vm._v("publicly visible")]), _vm._v(" in the catalog.")]), _c('li', [_vm._v("Upload image(s) for your cover using the "), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiImage)
    }
  }), _vm._v(" button. To fill the card exactly, an image should have a 5 x 7 aspect ratio. The cover you design will be used as the preview in the catalog.")], 1), _c('li', [_vm._v("Use the "), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiTextBox)
    }
  }), _vm._v(" button to add text using our built-in fonts. You can make any text user-editable by toggling \"Allow user editing\" in the entity context menu (right-click or click the "), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.iconPathBlobSettings)
    }
  }), _vm._v(" button at the bottom of the screen).")], 1), _c('li', [_vm._v("The entity context menu also gives you the ability to fine-tune the position of an entity by entering exact coordinates.")]), _c('li', [_vm._v("You can add an image template slot for the user to drop in custom photos using the "), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiImageEdit)
    }
  }), _vm._v(" button (make sure you set a placeholder image).")], 1), _c('li', [_vm._v("Use the "), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiTexture)
    }
  }), _vm._v(" background option in the "), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.iconPathPageSettings)
    }
  }), _vm._v(" card settings menu to add a background / texture to every page in your card.")], 1), _c('li', [_vm._v("If you are adding text that corresponds to an invitation "), _c('i', [_vm._v("event")]), _vm._v(" (e.g. the text shows the start time), you should add a "), _c('i', [_vm._v("smart field")]), _vm._v(" using the "), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCalendar)
    }
  }), _vm._v(" button. Note that you can customize or randomly generate sample event details.")], 1), _c('li', [_vm._v("Use the "), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPalette)
    }
  }), _vm._v(" button to set a default theme for your design (background, confetti, envelope stamp, font, and colors).")], 1), _c('li', [_vm._v("Use the "), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiTag)
    }
  }), _vm._v(" button to add category tags to your design. "), _c('b', [_vm._v("This is very important to make your design show up in search results")]), _vm._v(".")], 1), !_vm.isApplying ? [_c('li', [_vm._v("Use the preview button "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.mdiFileFind))]), _vm._v(" to see what your card will look like in different modes and make sure any user-editable sections will work as expected.")], 1), _c('li', [_vm._v("Use the "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.mdiCheck))]), _vm._v(" button to save your changes.")], 1), _c('li', [_vm._v("When you're satisfied with your design (and have saved it), click the "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.mdiFileUpload))]), _vm._v(" button to submit it to us.")], 1)] : _vm._e()], 2), _c('br'), _c('p', [_c('b', [_vm._v("Please make sure you own the rights to any content you add!")])])])], 2)], 1), _vm.showAddMedia ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.showAddMedia,
      callback: function ($$v) {
        _vm.showAddMedia = $$v;
      },
      expression: "showAddMedia"
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "float-right ma-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showAddMedia = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Add media")]), _c('v-card-text', [_c('v-select', {
    attrs: {
      "label": "Media type",
      "items": [{
        text: 'None',
        value: null
      }, {
        text: 'Frame / border',
        value: 'frame'
      }, {
        text: 'Texture',
        value: 'texture'
      }, {
        text: 'Background',
        value: 'background'
      }]
    },
    model: {
      value: _vm.addMedia.type,
      callback: function ($$v) {
        _vm.$set(_vm.addMedia, "type", $$v);
      },
      expression: "addMedia.type"
    }
  }), !_vm.addMedia.type ? [_c('div', {
    staticClass: "text--label-active mb-6"
  }, [_vm._v("A static image to be used as an accent anywhere within the design.")]), _c('v-file-input', {
    attrs: {
      "dense": "",
      "outlined": "",
      "single-line": "",
      "accept": "image/*",
      "label": "Image file"
    },
    model: {
      value: _vm.addMedia.img,
      callback: function ($$v) {
        _vm.$set(_vm.addMedia, "img", $$v);
      },
      expression: "addMedia.img"
    }
  })] : _vm.addMedia.type == 'background' ? [_c('div', {
    staticClass: "text--label-active mb-6"
  }, [_vm._v("A static image file with an aspect ratio of 5x7 and dimensions of at least 600x840. For animated backgrounds, you can also add a looping video file with the same aspect ratio. If you omit the static image for animated backgrounds, the first frame of your video will be automatically extracted. "), _c('span', {
    staticClass: "warning--text"
  }, [_vm._v("Use of this type is discouraged, as users will not be able to adjust the background color behind it. Use the "), _c('i', [_vm._v("Texture")]), _vm._v(" type instead if possible.")])]), _c('v-file-input', {
    attrs: {
      "dense": "",
      "outlined": "",
      "single-line": "",
      "accept": "image/*",
      "label": "Image file"
    },
    model: {
      value: _vm.addMedia.img,
      callback: function ($$v) {
        _vm.$set(_vm.addMedia, "img", $$v);
      },
      expression: "addMedia.img"
    }
  }), _c('v-file-input', {
    attrs: {
      "dense": "",
      "outlined": "",
      "single-line": "",
      "accept": "video/*",
      "label": "Video file"
    },
    model: {
      value: _vm.addMedia.video,
      callback: function ($$v) {
        _vm.$set(_vm.addMedia, "video", $$v);
      },
      expression: "addMedia.video"
    }
  })] : _vm.addMedia.type == 'frame' ? [_c('div', {
    staticClass: "text--label-active mb-6"
  }, [_vm._v("A static image file designed to align with a border / edge of the card.")]), _c('v-file-input', {
    attrs: {
      "dense": "",
      "outlined": "",
      "single-line": "",
      "accept": "image/*",
      "label": "Image file"
    },
    model: {
      value: _vm.addMedia.img,
      callback: function ($$v) {
        _vm.$set(_vm.addMedia, "img", $$v);
      },
      expression: "addMedia.img"
    }
  })] : _vm.addMedia.type == 'texture' ? [_c('div', {
    staticClass: "text--label-active mb-6"
  }, [_vm._v("A partially-transparent static image file with an aspect ratio of 5x7 and dimensions of at least 600x840 that can be overlaid on other content in the card or used as a background in conjunction with a user-defined color.")]), _c('v-file-input', {
    attrs: {
      "dense": "",
      "outlined": "",
      "single-line": "",
      "accept": "image/png",
      "label": "Image file"
    },
    model: {
      value: _vm.addMedia.img,
      callback: function ($$v) {
        _vm.$set(_vm.addMedia, "img", $$v);
      },
      expression: "addMedia.img"
    }
  })] : _vm._e(), _c('v-textarea', {
    attrs: {
      "dense": "",
      "label": "Description",
      "outlined": "",
      "hide-details": "",
      "auto-grow": "",
      "rows": "3"
    },
    model: {
      value: _vm.addMedia.description,
      callback: function ($$v) {
        _vm.$set(_vm.addMedia, "description", $$v);
      },
      expression: "addMedia.description"
    }
  })], 2), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "loading": _vm.submitMediaStatus.pending
    },
    on: {
      "click": _vm.submitMedia
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1) : _vm._e(), _vm.editEvent ? _c('dialog-scroll-lock', {
    attrs: {
      "content-class": "fill-height",
      "width": "500"
    },
    model: {
      value: _vm.editEvent,
      callback: function ($$v) {
        _vm.editEvent = $$v;
      },
      expression: "editEvent"
    }
  }, [_c('v-card', {
    staticClass: "fill-height overflow-auto"
  }, [_c('v-btn', {
    staticClass: "float-right ma-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.editEvent = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Invitation settings")]), _c('v-card-subtitle', [_vm._v("Where possible, invitations should include smart text fields that automatically link to the details of the user's event. This makes it so users don't have to redundantly enter their event details and reduces typos. To make a smart text field, open the settings for a selected text box "), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.iconPathBlobSettings)
    }
  }), _vm._v(" and click \"Link text to event\".")], 1), _c('v-divider'), _c('v-card-title', [_vm._v("Placeholder event")]), _c('v-card-subtitle', [_vm._v("For invitations, these event details will automatically link to smart fields as an example. Use the "), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiShuffleVariant)
    }
  }), _vm._v(" buttons to automatically generate random placeholder event properties.")], 1), _c('v-card-text', {
    staticClass: "pr-13"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('v-menu', {
    attrs: {
      "bottom": "",
      "offset-y": "",
      "content-class": "white"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticStyle: {
            "top": "6px",
            "right": "-44px"
          },
          attrs: {
            "absolute": "",
            "icon": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiShuffleVariant)
          }
        })], 1)];
      }
    }], null, false, 2060295637)
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.NAME_HINTS, function (hint) {
    return _c('v-list-item', {
      key: 'name-' + hint,
      on: {
        "click": function ($event) {
          _vm.design.event = Object.assign({}, _vm.design.event, _vm.generateName(hint));
          _vm.applyEventLinks();
        }
      }
    }, [_c('v-list-item-title', {
      domProps: {
        "textContent": _vm._s(hint)
      }
    })], 1);
  }), 1)], 1), _c('v-menu', {
    attrs: {
      "bottom": "",
      "offset-y": "",
      "content-class": "white"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticStyle: {
            "top": "102px",
            "right": "-44px"
          },
          attrs: {
            "absolute": "",
            "icon": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiShuffleVariant)
          }
        })], 1)];
      }
    }], null, false, 3002198608)
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.DATETIME_HINTS, function (hint) {
    return _c('v-list-item', {
      key: 'datetime-' + hint,
      on: {
        "click": function ($event) {
          _vm.design.event = Object.assign({}, _vm.design.event, _vm.generateDatetime(hint));
          _vm.applyEventLinks();
        }
      }
    }, [_c('v-list-item-title', {
      domProps: {
        "textContent": _vm._s(hint)
      }
    })], 1);
  }), 1)], 1), _c('v-menu', {
    attrs: {
      "bottom": "",
      "offset-y": "",
      "content-class": "white"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticStyle: {
            "top": "198px",
            "right": "-44px"
          },
          attrs: {
            "absolute": "",
            "icon": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiShuffleVariant)
          }
        })], 1)];
      }
    }], null, false, 4177641971)
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.LOCATION_HINTS, function (hint) {
    return _c('v-list-item', {
      key: 'location-' + hint,
      on: {
        "click": function ($event) {
          _vm.design.event = Object.assign({}, _vm.design.event, _vm.generateLocation(hint));
          _vm.applyEventLinks();
          _vm.$refs['event-location-form'].showAddress = true;
        }
      }
    }, [_c('v-list-item-title', {
      domProps: {
        "textContent": _vm._s(hint)
      }
    })], 1);
  }), 1)], 1)], 1), _c('v-textarea', {
    staticClass: "mb-4 inline-error",
    attrs: {
      "outlined": "",
      "auto-grow": "",
      "rows": "1",
      "persistent-placeholder": "",
      "label": "Event name"
    },
    model: {
      value: _vm.design.event.name,
      callback: function ($$v) {
        _vm.$set(_vm.design.event, "name", $$v);
      },
      expression: "design.event.name"
    }
  }), _c('div', {
    staticClass: "d-flex flex-wrap ma-n2"
  }, [_c('input-date', {
    staticClass: "ma-2",
    attrs: {
      "label": "Date"
    },
    model: {
      value: _vm.design.event.date_start,
      callback: function ($$v) {
        _vm.$set(_vm.design.event, "date_start", $$v);
      },
      expression: "design.event.date_start"
    }
  }), _c('div', {
    staticClass: "flex-grow-1 d-flex"
  }, [_c('input-time', {
    staticClass: "ma-2 flex-grow-1",
    attrs: {
      "label": "Start time"
    },
    model: {
      value: _vm.design.event.time_start,
      callback: function ($$v) {
        _vm.$set(_vm.design.event, "time_start", $$v);
      },
      expression: "design.event.time_start"
    }
  }), _c('input-time', {
    staticClass: "ma-2 flex-grow-1",
    attrs: {
      "label": "End time",
      "hint": _vm.design.event.time_end && _vm.design.event.time_end <= _vm.design.event.time_start ? '+1 day' : null
    },
    model: {
      value: _vm.design.event.time_end,
      callback: function ($$v) {
        _vm.$set(_vm.design.event, "time_end", $$v);
      },
      expression: "design.event.time_end"
    }
  })], 1), _c('div', {
    staticClass: "mt-n2 mx-2 mb-1"
  }, [_c('input-timezone', {
    model: {
      value: _vm.design.event.tz,
      callback: function ($$v) {
        _vm.$set(_vm.design.event, "tz", $$v);
      },
      expression: "design.event.tz"
    }
  })], 1)], 1), _c('event-location-form', {
    ref: "event-location-form",
    staticClass: "mt-n1",
    attrs: {
      "event": _vm.design.event
    }
  })], 1), _c('v-divider'), _c('v-card-title', [_vm._v("Preset layouts")]), _c('v-card-subtitle', [_vm._v("Jump-start your invititation's text layout by adding one of these presets. You can still make edits later."), _c('br'), _c('span', {
    staticClass: "warning--text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "warning"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" This will replace all existing smart text fields on the selected page.")], 1)]), _c('v-card-text', [_c('v-row', _vm._l(_vm.eventLayoutPresets, function (layout, i) {
    return _c('v-col', {
      key: i,
      attrs: {
        "cols": "4"
      }
    }, [_c('v-card', {
      attrs: {
        "hover": "",
        "tile": ""
      },
      on: {
        "click": function ($event) {
          return _vm.selectLayout(layout);
        }
      }
    }, [_c('card-preview', {
      attrs: {
        "card": layout
      }
    })], 1)], 1);
  }), 1)], 1)], 1)], 1) : _vm._e(), _c('dialog-scroll-lock', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.showDeleteConfirm,
      callback: function ($$v) {
        _vm.showDeleteConfirm = $$v;
      },
      expression: "showDeleteConfirm"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', [_vm._v("Delete design")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showDeleteConfirm = false;
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.mdiClose))])], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_vm._v(" Are you sure you want to delete this design? This action cannot be undone. ")]), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    on: {
      "click": function ($event) {
        _vm.showDeleteConfirm = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "loading": _vm.deleteDesign.pending,
      "color": "warning"
    },
    on: {
      "click": _vm.deleteDesign
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1), _c('dialog-scroll-lock', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.showSubmitConfirm,
      callback: function ($$v) {
        _vm.showSubmitConfirm = $$v;
      },
      expression: "showSubmitConfirm"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', [_vm._v("Submit design")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showSubmitConfirm = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1)], 1), _c('v-divider'), _vm.animatedBlobs.length ? [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('div', {
    staticClass: "overline"
  }, [_vm._v("Printing")]), _c('div', {
    staticClass: "mb-4"
  }, [_vm._v("Your card contains animated resources. Please upload a static version of those resources (with the same aspect ratio) so the card can be printed.")]), _c('v-row', {
    staticClass: "mb-n9"
  }, [_c('v-col', {
    staticClass: "overline text-center",
    attrs: {
      "cols": "6"
    }
  }, [_vm._v("Animated")]), _c('v-col', {
    staticClass: "overline text-center",
    attrs: {
      "cols": "6"
    }
  }, [_vm._v("Static")])], 1), _c('v-row', [_vm._l(_vm.animatedBlobs, function (blob) {
    return [_c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('v-responsive', {
      attrs: {
        "aspect-ratio": blob.w / blob.h
      }
    }, [_c('image-blob', {
      attrs: {
        "blob": blob
      }
    })], 1)], 1), _c('v-col', {
      staticClass: "relative d-flex justify-center",
      attrs: {
        "cols": "6"
      }
    }, [_c('v-responsive', {
      class: {
        'no-static-img grey lighten-4': !blob.img.src_static
      },
      attrs: {
        "aspect-ratio": blob.w / blob.h
      }
    }, [blob.img.src_static ? _c('image-blob', {
      attrs: {
        "blob": blob,
        "static": true
      }
    }) : _vm._e()], 1), _c('v-btn', {
      staticStyle: {
        "bottom": "0"
      },
      attrs: {
        "absolute": "",
        "color": blob.img.src_static ? null : 'primary',
        "loading": _vm.handleUploadStaticStatus.pending && _vm.targetBlob.id == blob.id
      },
      on: {
        "click": function ($event) {
          return _vm.promptUploadStatic(blob);
        }
      }
    }, [_vm._v(" " + _vm._s(blob.img.src_static ? 'Replace…' : 'Upload…') + " ")])], 1)];
  })], 2)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('div', {
    staticClass: "overline text-center"
  }, [_vm._v("Web preview")]), _c('card-preview', {
    attrs: {
      "card": _vm.design,
      "mode": "preview"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('div', {
    staticClass: "overline text-center"
  }, [_vm._v("Print preview")]), _c('card-preview', {
    attrs: {
      "card": _vm.design,
      "mode": "preview",
      "static": true
    }
  })], 1)], 1)], 1)] : _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "max-width": "300px"
    }
  }, [_c('card-preview', {
    attrs: {
      "mode": "preview",
      "card": _vm.design
    }
  })], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_vm._v(" Are you sure you're ready to submit this design? You won't be able to edit it again" + _vm._s((_vm.design || {}).private ? '' : ' unless we ask for revisions') + ". ")]), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    on: {
      "click": function ($event) {
        _vm.showSubmitConfirm = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "disabled": _vm.isSubmitDisabled,
      "loading": _vm.loadAnimatedImgBlobSrcsStatus.pending || _vm.submitDesign.pending,
      "color": "primary"
    },
    on: {
      "click": _vm.submitDesign
    }
  }, [_vm._v("Submit")])], 1)], 2)], 1), _vm.showMediaContextMenu ? _c('v-menu', {
    attrs: {
      "absolute": "",
      "close-on-content-click": false,
      "position-x": _vm.showMediaContextMenu.x,
      "position-y": _vm.showMediaContextMenu.y,
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.showMediaContextMenu = null;
      }
    }
  }, [_c('v-card', {
    attrs: {
      "width": "300"
    }
  }, [_c('v-btn', {
    staticClass: "float-right ma-3 mb-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showMediaContextMenu = null;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('div', {
    staticClass: "pt-5 px-4"
  }, [_c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("Type")]), _c('div', {
    staticClass: "overline short"
  }, [_vm._v(_vm._s(_vm.showMediaContextMenu.media.type || '–'))])]), _c('v-card-text', [(_vm$global$profile = _vm.global.profile) !== null && _vm$global$profile !== void 0 && _vm$global$profile.admin ? _c('v-textarea', {
    attrs: {
      "dense": "",
      "label": "Description",
      "outlined": "",
      "hide-details": "",
      "auto-grow": "",
      "rows": "4"
    },
    model: {
      value: _vm.showMediaContextMenu.stagedDescription,
      callback: function ($$v) {
        _vm.$set(_vm.showMediaContextMenu, "stagedDescription", $$v);
      },
      expression: "showMediaContextMenu.stagedDescription"
    }
  }) : [_c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("Description")]), _c('div', [_vm._v(_vm._s(_vm.showMediaContextMenu.stagedDescription))])]], 2), (_vm$global$profile2 = _vm.global.profile) !== null && _vm$global$profile2 !== void 0 && _vm$global$profile2.admin ? _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "error",
      "loading": _vm.deleteMediaStatus.pending
    },
    on: {
      "click": function ($event) {
        return _vm.deleteMedia(_vm.showMediaContextMenu.media.id);
      }
    }
  }, [_vm._v(" Delete ")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "disabled": _vm.showMediaContextMenu.stagedDescription == _vm.showMediaContextMenu.media.description,
      "loading": _vm.updateMediaDescriptionStatus.pending
    },
    on: {
      "click": function ($event) {
        return _vm.updateMediaDescription(_vm.showMediaContextMenu.media.id, _vm.showMediaContextMenu.stagedDescription);
      }
    }
  }, [_vm._v(" Update ")])], 1) : _vm._e()], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "fill-height d-flex flex-column"
  }, [_c('div', {
    staticClass: "flex-grow-0"
  }, [_c('div', {
    staticClass: "text-right float-sm-right ma-2 mb-0"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showHelp = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiHelpCircle)
    }
  })], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": ['UP', 'SUBMITTED'].includes(_vm.design.status),
      "input-value": _vm.editEvent
    },
    on: {
      "click": function ($event) {
        _vm.editEvent = !_vm.editEvent;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCalendar)
    }
  })], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": _vm.editTheme ? 'orange' : null,
      "input-value": _vm.editTheme
    },
    on: {
      "click": function ($event) {
        _vm.editTheme = !_vm.editTheme;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPalette)
    }
  })], 1), !_vm.isApplying ? [_c('v-btn', {
    attrs: {
      "icon": "",
      "target": "_blank",
      "to": {
        name: 'catalog',
        params: {
          selectedId: _vm.designId
        }
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiOpenInNew)
    }
  })], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "loading": _vm.cloneStatus.pending
    },
    on: {
      "click": _vm.clone
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiContentCopy)
    }
  })], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.isReadonly
    },
    on: {
      "click": function ($event) {
        _vm.showDeleteConfirm = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiDelete)
    }
  })], 1), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref4) {
        var on = _ref4.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "input-value": _vm.mode != 'design' && !_vm.isReadonly,
            "color": _vm.mode != 'design' && !_vm.isReadonly ? 'orange' : null
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiFileFind)
          }
        })], 1)];
      }
    }], null, false, 2240441954)
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, _vm._l(_vm.modes, function (_ref5) {
    var i = _ref5[0],
      j = _ref5[1];
    return _c('v-list-item', {
      key: i,
      attrs: {
        "disabled": _vm.isReadonly && i == 'design'
      },
      on: {
        "click": function ($event) {
          _vm.mode = i;
        }
      }
    }, [_c('v-list-item-icon', [i == _vm.mode ? _c('v-icon', {
      staticClass: "my-n2",
      domProps: {
        "innerHTML": _vm._s(_vm.mdiCheck)
      }
    }) : _vm._e()], 1), _c('v-list-item-content', [_c('v-list-item-title', {
      domProps: {
        "innerHTML": _vm._s(j)
      }
    })], 1)], 1);
  }), 1)], 1), (_vm$global$profile3 = _vm.global.profile) !== null && _vm$global$profile3 !== void 0 && _vm$global$profile3.org_admin ? _c('design-org-admin-btn', {
    staticClass: "d-inline-block",
    attrs: {
      "scope": "card",
      "target-id": _vm.designId
    }
  }) : _vm._e()] : _vm._e(), _c('tag-editor', {
    attrs: {
      "target-id": _vm.designId,
      "readonly": _vm.isReadonly,
      "scope": "card"
    }
  }), _vm.isApplying ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "small": "",
      "color": "primary",
      "loading": _vm.saveDesignStatus.pending
    },
    on: {
      "click": _vm.saveDesign
    }
  }, [_vm._v(" Done ")]) : [_c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.design || ['UP', 'SUBMITTED', 'DOWN'].includes(_vm.design.status)
    },
    on: {
      "click": _vm.trySubmit
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiFileUpload)
    }
  })], 1), _vm.isReadonly && (!_vm.dirty || !_vm.global.profile.admin) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "warning"
    },
    on: {
      "click": function ($event) {
        _vm.$confirm({
          title: 'Not editable',
          msg: `${_vm.design.status == 'SUBMITTED' ? 'This design is pending review and cannot be edited.' : 'This design is currently listed in the public Ellacard catalog and cannot be edited.'} You can still create a copy of this design and edit the copy.${_vm.global.profile.admin ? '<br><br><i>As an admin, you can still make changes to the theme without cloning / re-submitting the design.</i>' : ''}`,
          buttons: ['Ok'],
          primary: 'Ok'
        });
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  })], 1) : _c('v-btn', {
    attrs: {
      "icon": "",
      "input-value": _vm.dirty,
      "loading": _vm.saveDesignStatus.pending,
      "disabled": !_vm.design || !_vm.dirty,
      "color": _vm.dirty ? 'primary' : null
    },
    on: {
      "click": _vm.saveDesign
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCheck)
    }
  })], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "exact": "",
      "to": {
        name: 'account-design-cards',
        params: {}
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1)]], 2), _vm.design ? _c('v-text-field', {
    key: _vm.designId,
    staticClass: "ma-2",
    staticStyle: {
      "max-width": "400px"
    },
    attrs: {
      "disabled": _vm.isReadonly,
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "single-line": "",
      "label": "Design name",
      "error": !_vm.design.name
    },
    model: {
      value: _vm.design.name,
      callback: function ($$v) {
        _vm.$set(_vm.design, "name", $$v);
      },
      expression: "design.name"
    }
  }) : _c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  })], 1), _c('v-divider'), _c('div', {
    staticClass: "flex-grow-1 px-0 d-flex"
  }, [_c('div', {
    staticClass: "flex-grow-1 overflow-hidden relative"
  }, [_vm.design ? [_vm.editTheme ? _c('div', {
    staticClass: "fill-height d-flex flex-column pointer-events-auto"
  }, [_c('order-stepper-theme', {
    attrs: {
      "org-skin": _vm.isReadonly && !_vm.global.profile.admin ? _vm.design.skin : {},
      "order": Object.assign({}, _vm.design, {
        info: {
          to: '[&nbsp;recipient&nbsp;name&nbsp;]',
          from: '[&nbsp;sender&nbsp;name&nbsp;]'
        }
      }),
      "no-footer": true,
      "disable-to": true,
      "disable-from": true,
      "disable-multiple-recipients": true,
      "disable-logo": true
    },
    on: {
      "input": function (_ref6) {
        var skin = _ref6.skin;
        return _vm.$set(_vm.design, 'skin', skin);
      }
    }
  })], 1) : [_c('card-background', {
    attrs: {
      "src": _vm.design.skin.page_background_img
    }
  }), _c('card-editor', {
    key: _vm.mode,
    ref: "card-editor",
    attrs: {
      "is-owner": "",
      "card": _vm.design,
      "mode": _vm.mode
    },
    on: {
      "select-blob": function (x) {
        return _vm.selected = x;
      },
      "settings": function ($event) {
        _vm.show = 'settings';
      },
      "event-layout": function ($event) {
        _vm.show = 'event-layout';
      },
      "set-static-img": _vm.promptUploadStatic,
      "toggle-media-library": function ($event) {
        _vm.showMediaLibrary = !_vm.showMediaLibrary;
      }
    }
  })]] : _vm._e()], 2), _vm.showMediaLibrary ? _c('div', {
    staticClass: "elevation-20 white fill-height d-flex flex-column",
    staticStyle: {
      "z-index": "10",
      "right": "0",
      "width": "600px",
      "max-width": "90%",
      "height": "100%"
    },
    style: {
      position: _vm.$vuetify.breakpoint.smAndDown ? 'fixed' : null
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grow-0 d-flex flex-wrap align-end mt-3 mx-3"
  }, [_c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("Media library")]), _c('v-spacer'), _c('div', {
    staticClass: "ma-n1"
  }, [(_vm$global$profile4 = _vm.global.profile) !== null && _vm$global$profile4 !== void 0 && _vm$global$profile4.admin ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showAddMedia = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPlus)
    }
  })], 1) : _vm._e(), _vm.$vuetify.breakpoint.smAndDown ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showMediaLibrary = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1) : _vm._e()], 1)], 1), _c('v-text-field', {
    staticClass: "flex-grow-0 ma-3",
    attrs: {
      "outlined": "",
      "dense": "",
      "rounded": "",
      "hide-details": "",
      "clearable": "",
      "single-line": "",
      "label": "Filter"
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return function () {
          return null;
        }.apply(null, arguments);
      },
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
      },
      "click:clear": function () {
        return null;
      }
    },
    model: {
      value: _vm.mediaFilter,
      callback: function ($$v) {
        _vm.mediaFilter = $$v;
      },
      expression: "mediaFilter"
    }
  }), _vm.loadMediaLibraryStatus.pending ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }) : _c('v-virtual-scroll-grid', {
    staticClass: "flex-grow-1",
    attrs: {
      "bench": "1",
      "items": _vm.filteredMedia,
      "n": _vm.$vuetify.breakpoint.xsOnly ? 4 : 6,
      "aspect-ratio": 1,
      "padding": 12
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref7) {
        var media = _ref7.item,
          index = _ref7.index;
        return [_c('div', {
          staticClass: "media-item overflow-visible",
          on: {
            "click": function () {
              if (!_vm.showMediaContextMenu) _vm.insertBlob({
                type: 'IMG',
                x: 300,
                y: 420,
                w: media.w,
                h: media.h,
                img: media.is_animated ? {
                  src: `//cdn.ellacard.com/design-media-items/${media.key}.mp4`,
                  src_static: `//cdn.ellacard.com/design-media-items/${media.key}.webp`,
                  is_mp4: true
                } : {
                  src: `//cdn.ellacard.com/design-media-items/${media.key}.webp`
                }
              });
            },
            "contextmenu": function (e) {
              e.preventDefault();
              _vm.showMediaContextMenu = {
                media,
                x: e.clientX,
                y: e.clientY,
                stagedDescription: media.description
              };
            }
          }
        }, [media.is_animated ? _c('video', {
          attrs: {
            "playsinline": "",
            "autoplay": "",
            "muted": "",
            "loop": "",
            "width": 100 * Math.min(1, media.w / media.h) + '%',
            "poster": `//cdn.ellacard.com/design-media-items/${media.key}.webp`,
            "src": `//cdn.ellacard.com/design-media-items/${media.key}-preview.mp4`
          },
          domProps: {
            "muted": true
          }
        }) : _c('img', {
          attrs: {
            "width": 100 * Math.min(1, media.w / media.h) + '%',
            "src": `//cdn.ellacard.com/design-media-items/${media.key}.webp`
          }
        })])];
      }
    }], null, false, 3507756411)
  })], 1) : _vm._e()])], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }